import { type FlowLlmPromptBlock } from 'flow-schema';
import { useCallback, useMemo } from 'react';

import { type api, isDefined } from 'common';

import { MultipleFileReferencesField } from './MultipleFileReferencesField';
import { UploadFileProvider } from '../../../../../../../KnowledgeBase/fileUploadContext';
import { convertToFileReference } from '../../../../../../../KnowledgeBase/utils';
import { useSelectedNodeField } from '../../../ConfigFields/useSelectedNodeField';

export function FileReferencesField() {
  const { value: storedFileReferences, setValue: setStoredFileReferences } =
    useSelectedNodeField<FlowLlmPromptBlock['config']['fileReferences']>('config.fileReferences');

  const { value: storedFileReference, setValue: setStoredFileReference } =
    useSelectedNodeField<FlowLlmPromptBlock['config']['fileReference']>('config.fileReference');

  const fileReferences = useMemo(() => {
    if (isDefined(storedFileReference)) {
      return [...(storedFileReferences ?? []), storedFileReference];
    }
    return storedFileReferences;
  }, [storedFileReferences, storedFileReference]);

  const setFileReferences = useCallback(
    (newFileReferences: FlowLlmPromptBlock['config']['fileReferences']) => {
      setStoredFileReferences(newFileReferences);
      if (isDefined(storedFileReference)) {
        setStoredFileReference(undefined);
      }
    },
    [setStoredFileReferences, setStoredFileReference, storedFileReference]
  );

  return (
    <UploadFileProvider
      onFileUploaded={async (knowledgeBaseFile: api.KnowledgeBaseFile.KnowledgeBaseFile) => {
        setFileReferences([
          ...(fileReferences ?? []),
          convertToFileReference({ knowledgeBaseFileId: knowledgeBaseFile.id }),
        ]);
      }}
    >
      <MultipleFileReferencesField
        fileReferences={fileReferences}
        setFileReferences={setFileReferences}
      />
    </UploadFileProvider>
  );
}
